import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import localeMessage from '../../localeMessage';
import Send from '../../../../../../images/sessions/send.svg';

export function MessageForm({ connected, handleNewMessage, locale }) {
  const [message, setMessage] = useState('');
  const messageRef = useRef(message);
  const propsRef = useRef({ connected, handleNewMessage });
  messageRef.current = message;
  propsRef.current = { connected, handleNewMessage };

  const handleSubmit = useRef(() => {
    const { connected: isConnected, handleNewMessage: onNewMessage } =
      propsRef.current;
    const currentMessage = messageRef.current;

    if (isConnected && currentMessage !== '') {
      onNewMessage(currentMessage);
      setMessage('');
    }
  }).current;

  const handleEnter = useRef(event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  }).current;

  const handleChange = event => setMessage(event.target.value);

  return (
    <form className="sidebar-form" name="new_message">
      <div className="sidebar-input-container">
        <textarea
          className="sidebar-message-input"
          id="sidebar-message-input"
          rows="4"
          onChange={handleChange}
          onKeyDown={handleEnter}
          placeholder={localeMessage('typeMessage', locale)}
          value={message}
        />
        <div
          className="sidebar-message-send sidebar-pointer"
          onClick={handleSubmit}
          role="presentation"
        >
          <Send />
        </div>
      </div>
    </form>
  );
}

MessageForm.propTypes = {
  connected: PropTypes.bool.isRequired,
  handleNewMessage: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    locale: (state.user && state.user.locale) || 'en',
  };
}

export default connect(mapStateToProps)(MessageForm);
